module.exports = __webpack_public_path__ + "static/42-ThinkAnalytics-c59090dc937b629a0858c408325a6d78.png";